import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";

import {
  makeStyles,
  Paper,
  Grid,
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Dialog,
  DialogContent,
  Button,
  MenuItem,
  TextField,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

import CustomTextField from "../../../common-components/CustomTextField";
import { Select } from "antd";
import {
  formatDateBySetting,
  convertValuesFM,
  getResponse,
  converDateFormatForPicker,
} from "../../../shared-resources/utils";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";

import {
  getPSRDirectLaborAPI,
  getPSRHeadersAPI,
  getPSRindirectcostsAPI,
  updatePsrIndirectVariance,
  updatePsrRevenueVariance,
  getPSRotherdirectcostsAPI,
  getPSRRevenueAPI,
  getRvnClinDropdown,
  postPsrIndirectVariance,
  postPsrRevenueVariance,
  getPSRsubcontractorAPI,
  getPSRotherdirectcostsTotalAPI,
  getPSRTotalCostsAPI,
} from "../../../api/financial-management-api";
import {
  bindRevenue,
  bindDirectLabor,
  bindSubcontractor,
  bindOtherDirectCosts,
  bindTotaDirectCosts,
  bindInDirectCosts,
  bindInDirectVariance,
  bindInDirectTotal,
  bindTotaInDirectCosts,
} from "../components/MemoHelper";
const useStyles = makeStyles((theme) => ({
  headDataLabel: {
    height: "60px",
    height: "32px",
    textAlign: "center",
    alignContent: "center",
    fontWeight: 600,
    marginRight: "16px",
  },
  headDataValue: {
    height: "60px",
    height: "32px",
    textAlign: "center",
    alignContent: "center",
    width: "90px",
    border: "1px solid #6e6d6d",
    borderRadius: "5px",
    marginRight: "24px",
  },
  metaData: {
    width: "72px",
    textAlign: "center",
    alignContent: "center",
  },
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
  statusLabel: {
    fontSize: "13px",
    fontWeight: 600,
    marginRight: "6px",
  },
  highStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#c6efce",
    marginRight: "16px",
  },
  mediumStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#ffeb9c",
    marginRight: "16px",
  },
  lowStatus: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#ffc7ce",
    marginRight: "16px",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  inputStyle: {
    width: "85px",
    border: "1px solid #ccc",
    borderRadius: "3px",
    padding: "2px",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  popupBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "8px",
  },
  cancelBtnPopup: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
    marginLeft: "8px",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: "8px",
    fontSize: "13px",
  },
}));

const defaultSortOrder = [
  "Prior Year Actuals",
  "YTD Actuals",
  "Forecast ETC",
  "EAC",
  "Total for Year",
];

const rearrangeArray = (arr) => {
  if (arr.length < 3) {
    return arr; // If the array has less than 3 elements, return it as is
  }
  const newArry = [...arr];
  const lastThree = newArry.splice(-3); // Extract the last 3 elements
  return [...lastThree, ...newArry]; // Concatenate the extracted elements at the beginning
};

const PSRTrend = ({ contractId, version, yearValue }) => {
  const classes = useStyles();
  const revenuTableRef = useRef(null);
  const revenueVarianceRef = useRef(null);
  const revenueTotalRef = useRef(null);
  const directLabourRef = useRef(null);
  const subcontractorRef = useRef(null);
  const otherdirectcostsRef = useRef(null);
  const totaldirectcostsRef = useRef(null);
  const indirectCostsRef = useRef(null);
  const indirectVarianceRef = useRef(null);
  const indirectTotalRef = useRef(null);
  const totalindirectcostsRef = useRef(null);
  const [filteredRevenue, setFilteredRevenue] = useState([]);
  const [filteredRevenueVariance, setFilteredRevenueVariance] = useState([]);
  const [filteredDirectLabor, setFilteredDirectLabor] = useState([]);
  const [filteredSubcontractor, setFilteredSubcontractor] = useState([]);
  const [filteredOtherDirectCost, setFilteredOtherDirectCost] = useState([]);
  const [filteredIndirectVariance, setFilteredIndirectVariance] = useState([]);
  const [filteredInDirectCost, setFilteredInDirectCost] = useState([]);
  const [sortOrder, setSortOrder] = useState(defaultSortOrder);

  const [directLaborCostBind, setDirectLaborCostBind] = useState();
  const [revenueBind, setRevenueBind] = useState();
  const [psrHeaders, setPsrHeaders] = useState([]);
  const [subcontractorBind, setSubcontractorBind] = useState();
  const [otherdirectcostsBind, setOtherdirectcostsBind] = useState();
  const [indirectCostsBind, setIndirectCostsBind] = useState();
  const [loading, setLoading] = useState(true);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingRevenue, setIsEditingRevenue] = useState(false);
  const [showAddVarianceDialog, setShowAddVarianceDialog] = useState(false);
  const [clinOptions, setClinOptions] = useState([]);
  const [addVarianceForm, setAddVarianceForm] = useState({
    clin: "",
    varianceAmt: 0,
  });
  const [showAddRevenueVarianceDialog, setShowAddRevenueVarianceDialog] =
    useState(false);
  const [revenueVarianceForm, setRevenueVarianceForm] = useState({
    clin: "",
    varianceAmt: 0,
  });
  const detailedViewRatesData = useSelector(
    (state) => state.financialManagementReducer.detailedViewRatesData,
  );

  useEffect(() => {
    setLoading(true);
    (async () => {
      const [
        revenue,
        directLabor,
        subcontractor,
        otherdirectcosts,
        otherdirectcostsTotal,
        indirectcosts,
        totalCosts,
        psrHeadersRes,
      ] = await Promise.all([
        getPSRRevenueAPI(contractId, version, yearValue),
        getPSRDirectLaborAPI(contractId, version, yearValue),
        getPSRsubcontractorAPI(contractId, version, yearValue),
        getPSRotherdirectcostsAPI(contractId, version, yearValue),
        getPSRotherdirectcostsTotalAPI(contractId, version, yearValue),
        getPSRindirectcostsAPI(contractId, version, yearValue),
        getPSRTotalCostsAPI(contractId, version, yearValue),
        getPSRHeadersAPI(contractId, version, yearValue),
      ]);
      setLoading(false);
      setRevenueBind(revenue?.data);
      setSubcontractorBind(subcontractor?.data);
      setDirectLaborCostBind(directLabor?.data);
      setOtherdirectcostsBind({
        ...otherdirectcosts?.data,
        ...otherdirectcostsTotal?.data,
      });
      setIndirectCostsBind({ ...indirectcosts?.data, ...totalCosts?.data });
      setPsrHeaders(psrHeadersRes?.data);
      const order = psrHeadersRes?.data.map((item) => item.heading);
      setSortOrder([...defaultSortOrder, ...order]);
    })();
  }, [contractId, version, yearValue]);

  const handleScrollTable = (sourceTable) => {
    if (sourceTable === "revenueTable") {
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          revenuTableRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          revenuTableRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          revenuTableRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft = revenuTableRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          revenuTableRef.current.scrollLeft;
    } else if (sourceTable === "revenueVariance") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          revenueVarianceRef.current.scrollLeft;
    } else if (sourceTable === "revenueTotal") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = revenueTotalRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft = revenueTotalRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          revenueTotalRef.current.scrollLeft;
    } else if (sourceTable === "directLabor") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = directLabourRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          directLabourRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft = directLabourRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          directLabourRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          directLabourRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          directLabourRef.current.scrollLeft;
      /*if (indirectCostsRef.current)
      indirectCostsRef.current.scrollLeft = directLabourRef.current.scroll;
    if (totalindirectcostsRef.current)
      totalindirectcostsRef.current.scrollLeft = directLabourRef.current.scroll;*/
    } else if (sourceTable === "subcontractor") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = subcontractorRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          subcontractorRef.current.scrollLeft;
    } else if (sourceTable === "otherdirectcosts") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          otherdirectcostsRef.current.scrollLeft;
    } else if (sourceTable === "totaldirectcosts") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          totaldirectcostsRef.current.scrollLeft;
    } else if (sourceTable === "indirectCosts") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = indirectCostsRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (indirectVarianceRef.current)
        indirectVarianceRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (indirectTotalRef.current)
        indirectTotalRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          indirectCostsRef.current.scrollLeft;
    } else if (sourceTable === "indirectVariance") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (indirectTotalRef.current)
        indirectTotalRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          indirectVarianceRef.current.scrollLeft;
    } else if (sourceTable === "indirectTotal") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft = indirectTotalRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (indirectVarianceRef.current)
        indirectVarianceRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
      if (totalindirectcostsRef.current)
        totalindirectcostsRef.current.scrollLeft =
          indirectTotalRef.current.scrollLeft;
    } else if (sourceTable === "totalindirectcosts") {
      if (revenuTableRef.current)
        revenuTableRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (revenueVarianceRef.current)
        revenueVarianceRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (revenueTotalRef.current)
        revenueTotalRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (directLabourRef.current)
        directLabourRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (subcontractorRef.current)
        subcontractorRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (otherdirectcostsRef.current)
        otherdirectcostsRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (totaldirectcostsRef.current)
        totaldirectcostsRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
      if (indirectCostsRef.current)
        indirectCostsRef.current.scrollLeft =
          totalindirectcostsRef.current.scrollLeft;
    }
  };
  const handleEdit = () => setIsEditing(true);
  const handleRevenueEdit = () => setIsEditingRevenue(true);

  const handleVarianceChange = (varianceIndex, value) => {
    const list = indirectCostsBind?.psrIndirectVarianceList || [];
    if (varianceIndex >= list.length) return;
    const updatedList = list.map((item, i) => {
      if (i !== varianceIndex) return item;
      const monthDetail = item.monthExpenseDetail || [];
      const decMonthYear = sortOrder[sortOrder.length - 1];
      const decEntry = monthDetail.find((m) => m.monthYear === decMonthYear);
      const numVal = value === "" ? 0 : parseFloat(value) || 0;
      if (decEntry) {
        return {
          ...item,
          monthExpenseDetail: monthDetail.map((m) =>
            m.monthYear === decMonthYear ? { ...m, expense: numVal } : m,
          ),
        };
      }
      return {
        ...item,
        monthExpenseDetail: [
          ...monthDetail,
          {
            expenseDate: null,
            monthYear: decMonthYear,
            type: "Forecast",
            expense: numVal,
            isThresholdReached: decEntry?.isThresholdReached,
          },
        ],
      };
    });
    setIndirectCostsBind({
      ...indirectCostsBind,
      psrIndirectVarianceList: updatedList,
    });
  };

  const handleRevenueVarianceChange = (varianceIndex, value) => {
    const list = revenueBind?.psrRevenueVarianceList || [];
    if (varianceIndex >= list.length) return;
    const updatedList = list.map((item, i) => {
      if (i !== varianceIndex) return item;
      const monthDetail = item.monthExpenseDetail || [];
      const decMonthYear = sortOrder[sortOrder.length - 1];
      const decEntry = monthDetail.find((m) => m.monthYear === decMonthYear);
      const numVal = value === "" ? 0 : parseFloat(value) || 0;
      if (decEntry) {
        return {
          ...item,
          monthExpenseDetail: monthDetail.map((m) =>
            m.monthYear === decMonthYear ? { ...m, expense: numVal } : m,
          ),
        };
      }
      return {
        ...item,
        monthExpenseDetail: [
          ...monthDetail,
          {
            expenseDate: null,
            monthYear: decMonthYear,
            type: "Forecast",
            expense: numVal,
            isThresholdReached: decEntry?.isThresholdReached,
          },
        ],
      };
    });
    setRevenueBind({ ...revenueBind, psrRevenueVarianceList: updatedList });
  };

  const handleSave = () => {
    const list = indirectCostsBind?.psrIndirectVarianceList || [];
    if (list.length === 0) return;
    setLoading(true);
    const decMonthYear = sortOrder[sortOrder.length - 1];
    const payload = list.map((item) => {
      const monthDetail = item.monthExpenseDetail || [];
      const decEntry = monthDetail.find((m) => m.monthYear === decMonthYear);
      const decExpense = decEntry ? decEntry.expense : 0;
      return {
        project: item.project,
        projectName: item.projectName,
        monthExpenseDetail: [
          {
            expenseDate: decEntry?.expenseDate || null,
            monthYear: decMonthYear,
            type: decEntry?.type || "Forecast",
            expense: decExpense,
            isThresholdReached: decEntry?.isThresholdReached,
          },
        ],
      };
    });
    updatePsrIndirectVariance(contractId, version, yearValue, payload).then(
      (res) => {
        if (res.status === 200) {
          setIsEditing(false);
          Promise.all([
            getPSRindirectcostsAPI(contractId, version, yearValue),
            getPSRTotalCostsAPI(contractId, version, yearValue),
          ]).then(([indirectRes, totalRes]) => {
            if (indirectRes?.status === 200 && totalRes?.status === 200) {
              setIndirectCostsBind({
                ...indirectRes?.data,
                ...totalRes?.data,
              });
            }
            setLoading(false);
          });
          setEmptyErrMsg(true);
          setMsgType("success");
          setMsgText("Data updated successfully");
        } else if (res.status === 400) {
          setLoading(false);
          setEmptyErrMsg(true);
          setIsEditing(false);
          setMsgType("error");
          setMsgText(res.message || "Update failed");
        } else {
          setLoading(false);
        }
      },
    );
  };

  const handleCancel = () => {
    setIsEditing(false);
    Promise.all([
      getPSRindirectcostsAPI(contractId, version, yearValue),
      getPSRTotalCostsAPI(contractId, version, yearValue),
    ]).then(([indirectRes, totalRes]) => {
      if (indirectRes?.status === 200 && totalRes?.status === 200) {
        setIndirectCostsBind({
          ...indirectRes?.data,
          ...totalRes?.data,
        });
      }
    });
  };

  const handleRevenueSave = () => {
    const list = revenueBind?.psrRevenueVarianceList || [];
    if (list.length === 0) return;
    setLoading(true);
    const decMonthYear = sortOrder[sortOrder.length - 1];
    const payload = list.map((item) => {
      const monthDetail = item.monthExpenseDetail || [];
      const decEntry = monthDetail.find((m) => m.monthYear === decMonthYear);
      const decExpense = decEntry ? decEntry.expense : 0;
      return {
        project: item.project,
        projectName: item.projectName,
        monthExpenseDetail: [
          {
            expenseDate: decEntry?.expenseDate || null,
            monthYear: decMonthYear,
            type: decEntry?.type || "Forecast",
            expense: decExpense,
            isThresholdReached: decEntry?.isThresholdReached,
          },
        ],
      };
    });
    updatePsrRevenueVariance(contractId, version, yearValue, payload).then(
      (res) => {
        if (res?.status === 200) {
          setIsEditingRevenue(false);
          getPSRRevenueAPI(contractId, version, yearValue).then((revRes) => {
            if (revRes?.status === 200) setRevenueBind(revRes?.data);
            setLoading(false);
          });
          setEmptyErrMsg(true);
          setMsgType("success");
          setMsgText("Revenue variance updated successfully");
        } else if (res?.status === 400) {
          setLoading(false);
          setEmptyErrMsg(true);
          setIsEditingRevenue(false);
          setMsgType("error");
          setMsgText(res?.message || "Update failed");
        } else {
          setLoading(false);
        }
      },
    );
  };

  const handleRevenueCancel = () => {
    setIsEditingRevenue(false);
    getPSRRevenueAPI(contractId, version, yearValue).then((revRes) => {
      if (revRes?.status === 200) setRevenueBind(revRes?.data);
    });
  };

  const onAddNew = () => {
    setShowAddVarianceDialog(true);
    setAddVarianceForm({ clin: "", varianceAmt: 0 });
    getRvnClinDropdown(contractId).then((res) => {
      if (res?.status === 200 && Array.isArray(res?.data)) {
        setClinOptions(res.data);
      } else {
        setClinOptions([]);
      }
    });
  };
  const onAddRevenueNew = () => {
    setShowAddRevenueVarianceDialog(true);
    setRevenueVarianceForm({ clin: "", varianceAmt: 0 });
    getRvnClinDropdown(contractId).then((res) => {
      if (res?.status === 200 && Array.isArray(res?.data)) {
        setClinOptions(res.data);
      } else {
        setClinOptions([]);
      }
    });
  };
  const handleAddRevenueVarianceSubmit = () => {
    if (!revenueVarianceForm.clin) return;
    setLoading(true);
    const body = {
      contractId,
      clin: revenueVarianceForm.clin,
      version: Number(version),
      year: Number(yearValue),
      varianceAmt: Number(revenueVarianceForm.varianceAmt) || 0,
    };
    postPsrRevenueVariance(body).then((res) => {
      setLoading(false);
      if (res?.status === 200) {
        setShowAddRevenueVarianceDialog(false);
        setRevenueVarianceForm({ clin: "", varianceAmt: 0 });
        getPSRRevenueAPI(contractId, version, yearValue).then((revRes) => {
          if (revRes?.status === 200) setRevenueBind(revRes?.data);
        });
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Revenue variance added successfully");
      } else {
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res?.message || "Failed to add revenue variance");
      }
    });
  };

  const handleAddVarianceSubmit = () => {
    if (!addVarianceForm.clin) return;
    setLoading(true);
    const body = {
      contractId,
      clin: addVarianceForm.clin,
      version: Number(version),
      year: Number(yearValue),
      varianceAmt: Number(addVarianceForm.varianceAmt) || 0,
    };
    postPsrIndirectVariance(body).then((res) => {
      setLoading(false);
      if (res?.status === 200) {
        setShowAddVarianceDialog(false);
        setAddVarianceForm({ clin: "", varianceAmt: 0 });
        Promise.all([
          getPSRindirectcostsAPI(contractId, version, yearValue),
          getPSRTotalCostsAPI(contractId, version, yearValue),
        ]).then(([indirectRes, totalRes]) => {
          if (indirectRes?.status === 200 && totalRes?.status === 200) {
            setIndirectCostsBind({
              ...indirectRes?.data,
              ...totalRes?.data,
            });
          }
        });
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Variance added successfully");
      } else {
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res?.message || "Failed to add variance");
      }
    });
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const bindRevenueTable = useMemo(
    () =>
      bindRevenue({
        revenueBind,
        psrHeaders,
        handleScrollTable,
        revenuTableRef,
        sortOrder,
        filteredRevenue,
        setFilteredRevenue,
        classes,
        isEditingRevenue,
        handleRevenueVarianceChange,
      }),
    [
      revenueBind,
      psrHeaders,
      filteredRevenue,
      sortOrder,
      classes,
      isEditingRevenue,
      handleRevenueVarianceChange,
    ],
  );

  // const bindRevenueTotalTable = useMemo(
  //   () =>
  //     bindRevenueTotal({
  //       revenueBind,
  //       psrHeaders,
  //       handleScrollTable,
  //       revenueTotalRef,
  //       sortOrder,
  //     }),
  //   [revenueBind, psrHeaders, sortOrder],
  // );
  const bindDirectLaborTable = useMemo(
    () =>
      bindDirectLabor({
        directLaborCostBind,
        psrHeaders,
        handleScrollTable,
        directLabourRef,
        sortOrder,
        filteredDirectLabor,
        setFilteredDirectLabor,
      }),
    [directLaborCostBind, psrHeaders, filteredDirectLabor, sortOrder],
  );
  const bindSubcontractorTable = useMemo(
    () =>
      bindSubcontractor({
        subcontractorBind,
        psrHeaders,
        handleScrollTable,
        subcontractorRef,
        sortOrder,
        filteredSubcontractor,
        setFilteredSubcontractor,
      }),
    [subcontractorBind, psrHeaders, filteredSubcontractor, sortOrder],
  );
  const bindOtherDirectCostsTable = useMemo(
    () =>
      bindOtherDirectCosts({
        otherdirectcostsBind,
        psrHeaders,
        handleScrollTable,
        otherdirectcostsRef,
        sortOrder,
        filteredOtherDirectCost,
        setFilteredOtherDirectCost,
      }),
    [otherdirectcostsBind, psrHeaders, filteredOtherDirectCost, sortOrder],
  );
  const bindTotaDirectCoststable = useMemo(
    () =>
      bindTotaDirectCosts({
        rearrangeArray,
        otherdirectcostsBind,
        psrHeaders,
        handleScrollTable,
        totaldirectcostsRef,
        sortOrder,
      }),
    [otherdirectcostsBind, psrHeaders, sortOrder],
  );
  const bindInDirectCostsTable = useMemo(
    () =>
      bindInDirectCosts({
        indirectCostsBind,
        psrHeaders,
        handleScrollTable,
        indirectCostsRef,
        sortOrder,
        classes,
        isEditing,
        handleVarianceChange,
        onAddNew,
      }),
    [
      indirectCostsBind,
      psrHeaders,
      sortOrder,
      classes,
      isEditing,
      handleVarianceChange,
    ],
  );

  const bindInDirectVarianceTable = useMemo(
    () =>
      bindInDirectVariance({
        indirectCostsBind,
        psrHeaders,
        handleScrollTable,
        indirectVarianceRef,
        sortOrder,
        classes,
        isEditing,
        handleVarianceChange,
        filteredIndirectVariance,
        setFilteredIndirectVariance,
      }),
    [
      indirectCostsBind,
      psrHeaders,
      sortOrder,
      classes,
      isEditing,
      handleVarianceChange,
      filteredIndirectVariance,
    ],
  );

  const bindInDirectTotalTable = useMemo(
    () =>
      bindInDirectTotal({
        indirectCostsBind,
        psrHeaders,
        handleScrollTable,
        indirectTotalRef,
        sortOrder,
      }),
    [indirectCostsBind, psrHeaders, sortOrder],
  );

  const bindTotaInDirectCoststable = useMemo(
    () =>
      bindTotaInDirectCosts({
        rearrangeArray,
        indirectCostsBind,
        psrHeaders,
        handleScrollTable,
        totalindirectcostsRef,
        sortOrder,
      }),
    [indirectCostsBind, psrHeaders, sortOrder],
  );

  return (
    <div>
      <Grid container spacing={2} style={{ marginTop: "16px" }}>
        <Grid item lg={6}>
          <></>
        </Grid>
        {detailedViewRatesData && detailedViewRatesData.status === 200 && (
          <Grid item lg={6}>
            <Box
              display="flex"
              flexDirection="row"
              style={{
                float: "right",
                border: "1px solid #6e6d6d",
                borderRadius: "5px",
                height: "48px",
              }}
            >
              <Box
                style={{
                  width: "200px",
                  fontWeight: 600,
                  textAlign: "center",
                  alignContent: "center",
                  borderRight: "1px solid #6e6d6d",
                }}
              >
                {detailedViewRatesData.data.year} Forecasted Rates
              </Box>
              <Box className={classes.metaData}>
                <div>Fringe</div>
                <div>{detailedViewRatesData.data.fringe}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>OH</div>
                <div>{detailedViewRatesData.data.oh}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>SM&H</div>
                <div>{detailedViewRatesData.data.smAndH}%</div>
              </Box>
              <Box className={classes.metaData}>
                <div>G&A</div>
                <div>{detailedViewRatesData.data.gAndA}%</div>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
      <Grid container style={{ marginTop: "16px" }}>
        <Grid item lg={6}>
          <div className={classes.tableTitle}>Revenue</div>
        </Grid>
        {/* <Grid item lg={6}>
          <Box display="flex" flexDirection="row" style={{ float: "right" }}>
            <Box display="flex" alignItems="center" flexDirection="row">
              {!isEditingRevenue && (
                <div
                  className={classes.editBtn}
                  onClick={onAddRevenueNew}
                  style={{
                    marginTop: "-2px",
                    cursor: "pointer",
                    marginRight: "8px",
                  }}
                >
                  <span className={classes.editText}>+ Add</span>
                </div>
              )}
              <Box>
                {!isEditingRevenue ? (
                  <div className={classes.editBtn} onClick={handleRevenueEdit}>
                    <EditIcon className={classes.editIcon} />
                    <span className={classes.editText}> Edit </span>
                  </div>
                ) : (
                  <>
                    <span
                      className={classes.saveBtn}
                      onClick={handleRevenueSave}
                    >
                      Save
                    </span>
                    <span
                      className={classes.cancelBtn}
                      onClick={handleRevenueCancel}
                    >
                      Cancel
                    </span>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Grid> */}
      </Grid>
      {bindRevenueTable}
      {/* {bindRevenueTotalTable} */}
      <div className={classes.tableTitle} style={{ marginTop: "16px" }}>
        Direct Labor
      </div>
      {bindDirectLaborTable}
      <div className={classes.tableTitle} style={{ marginTop: "16px" }}>
        Subcontractor Labor
      </div>
      {bindSubcontractorTable}
      <div className={classes.tableTitle} style={{ marginTop: "16px" }}>
        Other Direct Costs
      </div>
      {bindOtherDirectCostsTable}
      <div style={{ marginTop: "16px" }}>{bindTotaDirectCoststable}</div>
      <Grid item lg={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: "40px" }}
        >
          <div className={classes.tableTitle}> Indirect Costs</div>

          <Box display="flex" alignItems="center" flexDirection="row">
            {onAddNew && !isEditing && (
              <div
                className={classes.editBtn}
                onClick={onAddNew}
                style={{
                  marginTop: "-2px",
                  cursor: "pointer",
                  marginRight: "8px",
                }}
              >
                <span className={classes.editText}>+ Add</span>
              </div>
            )}
            <Box>
              {!isEditing ? (
                <div className={classes.editBtn} onClick={handleEdit}>
                  <EditIcon className={classes.editIcon} />
                  <span className={classes.editText}> Edit </span>
                </div>
              ) : (
                <>
                  <span className={classes.saveBtn} onClick={handleSave}>
                    Save
                  </span>
                  <span className={classes.cancelBtn} onClick={handleCancel}>
                    Cancel
                  </span>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Grid>
      {/* <div className={classes.tableTitle} style={{ marginTop: "16px" }}>
        Indirect Costs
      </div> */}
      {bindInDirectCostsTable}
      {bindInDirectVarianceTable}
      {bindInDirectTotalTable}
      {bindTotaInDirectCoststable}
      {loading && <Loading />}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {showAddVarianceDialog && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="add-variance-dialog"
          open={showAddVarianceDialog}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => {
                  setShowAddVarianceDialog(false);
                  setAddVarianceForm({ clin: "", varianceAmt: 0 });
                }}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Add New Variance</div>
            </div>

            <Grid container spacing={2}>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Select CLIN
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  options={clinOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={(val) =>
                    setAddVarianceForm({ ...addVarianceForm, clin: val })
                  }
                  value={addVarianceForm.clin}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Variance Amount
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <CustomTextField
                  selectedValue={addVarianceForm.varianceAmt}
                  onChangeItem={(e) =>
                    setAddVarianceForm({
                      ...addVarianceForm,
                      varianceAmt: e.target.value,
                    })
                  }
                  labelVal="Variance Amount"
                  id="varianceAmt"
                  type="number"
                />
              </Grid>
            </Grid>

            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.popupBtn}
                variant="contained"
                color="primary"
                onClick={handleAddVarianceSubmit}
                disabled={
                  !addVarianceForm.clin ||
                  !addVarianceForm.varianceAmt ||
                  addVarianceForm.varianceAmt === 0
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtnPopup}
                color="primary"
                onClick={() => {
                  setShowAddVarianceDialog(false);
                  setAddVarianceForm({ clin: "", varianceAmt: 0 });
                }}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {showAddRevenueVarianceDialog && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="add-revenue-variance-dialog"
          open={showAddRevenueVarianceDialog}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => {
                  setShowAddRevenueVarianceDialog(false);
                  setRevenueVarianceForm({ clin: "", varianceAmt: 0 });
                }}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>
                Add New Revenue Variance
              </div>
            </div>

            <Grid container spacing={2}>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Select CLIN
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  options={clinOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={(val) =>
                    setRevenueVarianceForm({
                      ...revenueVarianceForm,
                      clin: val,
                    })
                  }
                  value={revenueVarianceForm.clin}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Variance Amount
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <CustomTextField
                  selectedValue={revenueVarianceForm.varianceAmt}
                  onChangeItem={(e) =>
                    setRevenueVarianceForm({
                      ...revenueVarianceForm,
                      varianceAmt: e.target.value,
                    })
                  }
                  labelVal="Variance Amount"
                  id="revenueVarianceAmt"
                  type="number"
                />
              </Grid>
            </Grid>

            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.popupBtn}
                variant="contained"
                color="primary"
                onClick={handleAddRevenueVarianceSubmit}
                disabled={
                  !revenueVarianceForm.clin ||
                  !revenueVarianceForm.varianceAmt ||
                  revenueVarianceForm.varianceAmt === 0
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtnPopup}
                color="primary"
                onClick={() => {
                  setShowAddRevenueVarianceDialog(false);
                  setRevenueVarianceForm({ clin: "", varianceAmt: 0 });
                }}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default PSRTrend;
